import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  GmouStoreActions,
  GmouStoreSelectors,
  GmouStoreReducer,
} from './index';
import { GMOUDto } from '@cradua/data';

@Injectable()
export class GmouFacade {
  constructor(private store: Store<GmouStoreReducer.GmouPartialState>) {}

  projectManagementRecord$ = this.store.select(GmouStoreSelectors.getSelected);
  searchedStudentRecord$ = this.store.select(
    GmouStoreSelectors.getSearchStudentRecord
  );

  projectManagementRecordError$ = this.store.select(
    GmouStoreSelectors.getGmouError
  );

  getselected() {
    return this.store.select(GmouStoreSelectors.getSelected);
  }

  get isLoadingGmou() {
    this.store.dispatch(GmouStoreActions.loadGmou());
    return this.store.select(GmouStoreSelectors.loadingGmou);
  }

  get loadGmou() {
    this.store.dispatch(GmouStoreActions.loadGmou());
    return this.store.select(GmouStoreSelectors.getAllGmou);
  }

  searchStudentRecord(query) {
    this.store.dispatch(GmouStoreActions.searchGmouRecord({ query }));
  }

  addGmou(newGmou: GMOUDto) {
    this.store.dispatch(
      GmouStoreActions.addGmou({
        newGmou,
      })
    );
  }

  updateGmou(updateGmou: GMOUDto) {
    this.store.dispatch(
      GmouStoreActions.updateGmou({
        updateGmou,
      })
    );
  }

  removeGmou(ids: string) {
    this.store.dispatch(GmouStoreActions.removeGmou({ ids }));
  }
}
